import React, { useState, useEffect } from "react";
//component
import {
  firefunctions,
  analytics,
} from "../../../components/firebase/FirebaseProvider";
import { productsCollection } from "../../../components/firebase/DataProvider";
import { useDocumentDataOnce } from "react-firebase-hooks/firestore";
//material comoponent
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@material-ui/lab/Skeleton";
//slider
import ScrollContainer from "react-indiana-drag-scroll";

//style
import useStyles from "./style/koleksiPilihanStyle";

import { useHistory } from "react-router-dom";
import slugify from "slugify";
import { Typography } from "@material-ui/core";

function Item({ id, key, load }) {
  const classes = useStyles();
  const history = useHistory();
  const [data] = useDocumentDataOnce(productsCollection.doc(id), {
    idField: "id",
  });

  // seceleton
  const [sece, setSece] = useState();
  setTimeout(() => {
    setSece(data);
  }, 1000);

  const toDetailProduct = (id, title) => () => {
    analytics.logEvent("view_product", { name: title, id: id });

    history.push(`/produk/${slugify(title.toLowerCase())}/${id}`);
  };

  return (
    <div className={classes.wrapper} key={key}>
      {!sece || load ? (
        <div className={classes.card}>
          <Skeleton variant="rect" className={classes.img} />
        </div>
      ) : (
        <Card
          className={classes.card}
          onClick={toDetailProduct(data?.id, data?.nama)}
        >
          <CardActionArea>
            <div
              loading="lazy"
              // src={data.thumbnail[0]}
              // alt={data.id}
              className={classes.img}
              style={{
                backgroundImage: `url(${data.thumbnail[0]})`,
              }}
            />
          </CardActionArea>
        </Card>
      )}
    </div>
  );
}

function KoleksiPilihan() {
  const classes = useStyles();

  const [items, setItems] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function getItems() {
      setIsLoading(true);
      try {
        const getPopuler = firefunctions.httpsCallable("getPopular");

        const response = await getPopuler({ find_by: "produk" });

        setItems(response.data.popular_items);
      } catch (e) {
        // console.log(e.message);
      }
      setIsLoading(false);
    }

    getItems();
  }, []);

  return (
    <Paper elevation={0} className={classes.container}>
      <div style={{ marginTop: 10, marginBottom: 15 }}>
        <Typography
          style={{
            fontSize: "13px",
            fontWeight: "bold",
            textTransform: "uppercase",
          }}
        >
          Koleksi Pilihan
        </Typography>
      </div>
      <div className={classes.wrapKategori}>
        {isLoading ? (
          <div className={classes.card}>
            <Skeleton variant="rect" className={classes.img} />
          </div>
        ) : (
          <ScrollContainer className={classes.wrapScroll}>
            {items.map((item, index) => {
              return <Item id={item.id_produk} key={index} load={isLoading} />;
            })}
          </ScrollContainer>
        )}
      </div>
    </Paper>
  );
}

export default KoleksiPilihan;
